import { useMemo } from 'react';

import { SkeletonLoader } from '@kanda-libs/ks-design-library';

import ApplyCard from '../components/Card';

export interface FieldLoaderProps {
  colspan?: 1 | 2 | 3 | 4 | 5 | 6;
}

const FieldLoader: React.FunctionComponent<FieldLoaderProps> = function ({
  colspan = 6,
}) {
  const colSpanClassName = useMemo(() => {
    if (colspan === 1) return 'col-span-1';
    if (colspan === 2) return 'col-span-2';
    if (colspan === 3) return 'col-span-3';
    if (colspan === 4) return 'col-span-4';
    if (colspan === 5) return 'col-span-5';
    return 'col-span-6';
  }, [colspan]);
  return (
    <div className={`flex flex-col ${colSpanClassName}`}>
      <SkeletonLoader height={12} isLoading wrapperClassName="w-1/2 min-w-20" />
      <SkeletonLoader height={32} isLoading />
    </div>
  );
};

const FormGroupLoader: React.FunctionComponent<FieldLoaderProps> = function () {
  return (
    <ApplyCard>
      <div className="grid grid-cols-6 w-full gap-x-3 md:gap-x-4 gap-y-3">
        <SkeletonLoader
          height={24}
          isLoading
          wrapperClassName="max-w-80 col-span-6"
        />
        <SkeletonLoader
          height={20}
          isLoading
          wrapperClassName="max-w-60 col-span-6"
        />
        <FieldLoader colspan={3} />
        <FieldLoader colspan={3} />
        <FieldLoader colspan={3} />
        <FieldLoader colspan={3} />
        <FieldLoader colspan={6} />
        <FieldLoader colspan={2} />
        <FieldLoader colspan={2} />
        <FieldLoader colspan={2} />
      </div>
    </ApplyCard>
  );
};

const FormLoader: React.FunctionComponent = function () {
  return (
    <div className="flex flex-col gap-y-6">
      <FormGroupLoader />
      <FormGroupLoader />
      <FormGroupLoader />
      <FormGroupLoader />
      <FormGroupLoader />
      <FormGroupLoader />
    </div>
  );
};

export default FormLoader;
